import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../../../utils';
import DateRangePicker from './DateRangePicker';
// eslint-disable-next-line no-unused-vars
const DateRangePickerContainerStyled = styled('div')(() => ({
    position: 'relative',
}));
const DateRangePickerStyled = styled('div')(() => ({
    position: 'relative',
    zIndex: 1,
}));
const DateRangePickerBackdropStyled = styled('div')(() => ({
    position: 'fixed',
    height: '100vh',
    width: '100vw',
    bottom: 0,
    zIndex: 0,
    right: 0,
    left: 0,
    top: 0,
}));
const DateRangePickerWrapper = (props) => {
    const { closeOnClickOutside, wrapperClassName, toggle, open } = props;
    const handleToggle = () => {
        if (closeOnClickOutside === false) {
            return;
        }
        toggle();
    };
    const handleKeyPress = (event) => event?.key === 'Escape' && handleToggle();
    return (_jsxs(DateRangePickerContainerStyled, { children: [open && (_jsx(DateRangePickerBackdropStyled, { onKeyPress: handleKeyPress, onClick: handleToggle })), _jsx(DateRangePickerStyled, { className: wrapperClassName, children: _jsx(DateRangePicker, { ...props }) })] }));
};
export default DateRangePickerWrapper;
